import ReactDOM from 'react-dom/client';
import './index.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import "bootstrap-icons/font/bootstrap-icons.css";
import App from './App';
import reportWebVitals from './reportWebVitals';
import { PrimeReactProvider } from 'primereact/api';
import ResponseInterceptor from './service/interceptor/responseInterceptor.component';
import PopupInstallComponent from './components/PopupInstall/popupInstall.component';
import { ConnectivityProvider } from './context/connectivityContext';

// const registerServiceWorker = async () => {
//   if ("serviceWorker" in navigator) {
//     try {
//       const registration = await navigator.serviceWorker.register("/sw.js", {
//         scope: "/",
//       });
//       if (registration.installing) {
//         console.log("Service worker installing");
//       } else if (registration.waiting) {
//         console.log("Service worker installed");
//       } else if (registration.active) {
//         console.log("Service worker active");
//       }
//     } catch (error) {
//       console.error(`Registration failed with ${error}`);
//     }
//   }
// };


// registerServiceWorker();


const onScroll = () => {
  var elm = document.querySelector('.subHeader') as HTMLElement
  //if(window.location.pathname !== ('/login' && '/menu' && '/signup')){
  if (elm) {
  if (window.scrollY > 100) {
    console.log('user scrolled over 100')
    elm.classList.add('hide');
  } else {
    elm.classList.remove('hide');
  }
  }
  
}

window.addEventListener('scroll', onScroll, true);


// var container = document.querySelector("body") as HTMLElement;

//   container.addEventListener("touchstart", startTouch, false);
//   container.addEventListener("touchmove", moveTouch, false);

//   // Swipe Up / Down / Left / Right
//   var initialX: number | null = null;
//   var initialY: number | null = null;

//   function startTouch(e:any) {
//     initialX = e.touches[0].clientX;
//     initialY = e.touches[0].clientY;
//   };

//   function moveTouch(e:any) {
//     if (initialX === null) {
//       return;
//     }

//     if (initialY === null) {
//       return;
//     }

//     var currentX = e.touches[0].clientX;
//     var currentY = e.touches[0].clientY;

//     var diffX = initialX - currentX;
//     var diffY = initialY - currentY;

//     if (Math.abs(diffX) > Math.abs(diffY)) {
//       // sliding horizontally
//       if (diffX > 0) {
//         // swiped left
//         console.log("swiped left");
//       } else {
//         // swiped right
//         console.log("swiped right");
//       }  
//     } else {
//       // sliding vertically
//       if (diffY > 0) {
//         // swiped up
//         console.log("swiped up");
//       } else {
//         // swiped down
//         if ((diffY - (-10)) < -20){
//           console.log("swiped down");
//           localStorage.removeItem("services");
//           localStorage.removeItem("allCustomerInfo");
//           localStorage.removeItem("pharmacyInfo");
//           localStorage.removeItem("catalogs");
//           localStorage.removeItem("points");
//           localStorage.removeItem("rewards");

//           window.location.reload();
//         }
        
//       }  
//     }

//     initialX = null;
//     initialY = null;

//     //e.preventDefault();
//   };

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(

  <PrimeReactProvider>
    <PopupInstallComponent/>
    <ConnectivityProvider>
      <App/>
    </ConnectivityProvider>
    <ResponseInterceptor/>
  </PrimeReactProvider>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();